import type { FunctionComponent } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';
import type { LanguageCode } from '~/shared/internationalization';
import type { ButtonProps } from '~/ui/core/button/Button';
import type { Language } from '~/ui/domain/language-picker/LanguagePicker';
import { LanguagePicker } from '~/ui/domain/language-picker/LanguagePicker';

import { useSnackbars } from '../error-handling/SnackBars';

type LanguageSelectProps = {
    readonly disabled?: boolean;
    readonly fullWidth?: boolean;
    readonly isLabelVisible?: boolean;
    readonly isUnderlineDisabled?: boolean;
    readonly size?: ButtonProps['size'];
    readonly variant?: ButtonProps['variant'];
};

export const LanguageSelect: FunctionComponent<LanguageSelectProps> = ({
    disabled,
    size = 'sm',
    variant = 'secondary',
}) => {
    const { actions, applicationState } = useApplicationContext();
    const { availableLanguages, languageKey } = applicationState;
    const { showErrorSnackbar } = useSnackbars();

    const languages: readonly Language<LanguageCode>[] = Object.values(availableLanguages).flatMap((config) =>
        config === undefined
            ? []
            : [
                  {
                      id: config.code,
                      name: config.name,
                  },
              ],
    );
    const activeText = availableLanguages[languageKey]?.name;

    return (
        <LanguagePicker
            activeText={activeText}
            buttonProps={{ size, variant }}
            disabled={disabled}
            languages={languages}
            onLanguageChange={(language) => {
                try {
                    actions.setLanguage(language);
                } catch (error) {
                    showErrorSnackbar(error);
                }
            }}
        />
    );
};
